import { render, staticRenderFns } from "./ApprovalManagement.vue?vue&type=template&id=13fa0056&scoped=true"
import script from "./ApprovalManagement.vue?vue&type=script&lang=js"
export * from "./ApprovalManagement.vue?vue&type=script&lang=js"
import style0 from "./ApprovalManagement.vue?vue&type=style&index=0&id=13fa0056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa0056",
  null
  
)

export default component.exports